import { FormControl, MenuItem, Select, Stack, SxProps, Typography } from '@mui/material';
import moment from 'moment';
import useTtsReferenceModels from '../../../hooks/useTtsReferenceModels';

type Props = {
    ttsModelId?: string | undefined | null;
    handleTtsModelIdChange: (modelId: string | null) => void;
    size?: 'small' | 'medium';
    disabled?: boolean;
    sx?: SxProps;
};

const TtsOnlyStrugglesVoiceModelSelector = (props: Props) => {
    const { ttsModelId, handleTtsModelIdChange, size, disabled, sx } = props;

    const { data: models, isLoading: loading, refetch: loadModels } = useTtsReferenceModels();

    return (
        <FormControl fullWidth error={!loading && (!ttsModelId || ttsModelId === '')}>
            <Select
                id="tts-model"
                fullWidth
                variant="outlined"
                size={size}
                disabled={disabled || loading}
                value={ttsModelId}
                displayEmpty
                onChange={e => {
                    handleTtsModelIdChange(e.target.value);
                }}
                sx={sx}
            >
                {loading && <MenuItem disabled>Loading...</MenuItem>}
                {models?.length === 0 && <MenuItem disabled>No TTS models available</MenuItem>}
                {models && models.length > 0 && <MenuItem value="">Select a TTS model</MenuItem>}
                {models?.map(model => (
                    <MenuItem key={model._id} value={model.modelId}>
                        <Stack direction="row" spacing={1} alignItems="center" justifyContent={'space-between'} sx={{ width: '100%' }}>
                            <Typography variant="body1">{model.name}</Typography>
                            <Typography variant="body1" color={'text.secondary'}>
                                {moment(model.createdAt).format('L')}
                            </Typography>
                        </Stack>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default TtsOnlyStrugglesVoiceModelSelector;
